import { UserRole } from '../../types/user-role';
import { DASHBOARD_URL, USER_MANAGEMENT_URL } from '../constants/route-paths';

/** Pure permission rules. `AuthService` wraps these in `computed()`s. */

/** Admin (own company) and SuperAdmin (all companies) may open User Management. */
export function roleCanManageUsers(role: UserRole | null): boolean {
  return role === UserRole.Admin || role === UserRole.SuperAdmin;
}

/**
 * Conversions (dashboard, XBRL files, filing). A SuperAdmin is refused by the
 * backend with 403 `SUPERADMIN_MODULE_FORBIDDEN`, so the UI never offers them.
 */
export function roleCanUseConversions(role: UserRole | null): boolean {
  return role === UserRole.User || role === UserRole.Admin;
}

/**
 * Roles the caller may assign when creating or editing a user. `SuperAdmin`
 * is never offered: the backend rejects it (`SUPERADMIN_ROLE_NOT_ASSIGNABLE`).
 */
export function assignableRolesFor(role: UserRole | null): UserRole[] {
  switch (role) {
    case UserRole.SuperAdmin:
    case UserRole.Admin:
      // An Admin may add another Admin to their own company (the company picker
      // is locked to it); only SuperAdmin is never assignable.
      return [UserRole.User, UserRole.Admin];
    default:
      return [];
  }
}

/** The page a signed-in customer-area user lands on. */
export function homeUrlFor(role: UserRole | null): string {
  return role === UserRole.SuperAdmin ? USER_MANAGEMENT_URL : DASHBOARD_URL;
}
